export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Necesito vivir en la montaña para entrenar esto?',
    answer:
      'No. El 70% de mis alumnos vive en ciudades planas. Te enseño cómo simular el desnivel y fortalecer las piernas en cualquier lugar: escaleras, cinta, puentes y trabajo de fuerza específico.',
  },
  {
    question: '¿Es para principiantes?',
    answer:
      'Absolutamente. Si recién empezás, este plan te va a ahorrar meses de lesiones y errores básicos. Y si ya corrés hace años, vas a encontrar el trabajo de fuerza y descenso que te falta.',
  },
  {
    question: '¿Qué pasa si no me gusta?',
    answer:
      'Tenés 7 días de garantía total. Si no sentís que es para vos, te devuelvo el dinero sin preguntas.',
  },
]
